// const server = "http://localhost";
// const domain = "localhost";
// const port = 9120;
const server = process.env.API_URL || "https://api.lanuevatendencia.com";
const port = process.env.API_PORT || 443;
const domain = "admin.lanuevatendencia.com";
export { server, port, domain };
